// Every place AirLoo serves. To add or change a city, edit this list.
//
// The page for each city is created automatically at
//   /portable-toilets-on-rent/<slug>
// and the city is added to the footer, the SEO titles and descriptions.
//
// group:  'bangalore' = an area in or around Bangalore, 'karnataka' = another Karnataka city,
//         'tamilnadu' = a city in Tamil Nadu
// alt:    the other spelling people search for (used in titles and text)
// nearby: slugs of nearby service areas (used for the "nearby areas" links)
// note:   OPTIONAL. Real local details for that city, for example
//         note: 'We deliver to Mysuru from our Bangalore depot, usually the day before your event.'
//         Add a note only if it is true. City pages with real details rank better.

export const CITY_BASE_PATH = '/portable-toilets-on-rent';

export const cities = [
  // Bangalore and around
  { slug: 'koramangala', name: 'Koramangala', group: 'bangalore', nearby: ['hsr-layout', 'indiranagar', 'jayanagar'] },
  { slug: 'indiranagar', name: 'Indiranagar', group: 'bangalore', nearby: ['koramangala', 'marathahalli', 'whitefield'] },
  { slug: 'whitefield', name: 'Whitefield', group: 'bangalore', nearby: ['marathahalli', 'hoskote', 'indiranagar'] },
  { slug: 'jayanagar', name: 'Jayanagar', group: 'bangalore', nearby: ['koramangala', 'hsr-layout', 'electronic-city'] },
  { slug: 'hsr-layout', name: 'HSR Layout', group: 'bangalore', nearby: ['koramangala', 'jayanagar', 'electronic-city'] },
  { slug: 'electronic-city', name: 'Electronic City', group: 'bangalore', nearby: ['hsr-layout', 'bommasandra', 'hebbagodi', 'chandapura', 'hosur'] },
  { slug: 'marathahalli', name: 'Marathahalli', group: 'bangalore', nearby: ['whitefield', 'indiranagar'] },
  { slug: 'malleshwaram', name: 'Malleshwaram', group: 'bangalore', nearby: ['yelahanka', 'indiranagar'] },
  { slug: 'anekal', name: 'Anekal', group: 'bangalore', nearby: ['electronic-city', 'hebbagodi', 'bommasandra', 'chandapura', 'hosur'] },
  { slug: 'devanahalli', name: 'Devanahalli', group: 'bangalore', nearby: ['yelahanka', 'hoskote'] },
  { slug: 'yelahanka', name: 'Yelahanka', group: 'bangalore', nearby: ['devanahalli', 'malleshwaram', 'nelamangala'] },
  { slug: 'hoskote', name: 'Hoskote', group: 'bangalore', nearby: ['whitefield', 'devanahalli'] },
  { slug: 'nelamangala', name: 'Nelamangala', group: 'bangalore', nearby: ['yelahanka', 'magadi', 'tumakuru'] },
  { slug: 'magadi', name: 'Magadi', group: 'bangalore', nearby: ['nelamangala'] },
  { slug: 'hebbagodi', name: 'Hebbagodi', group: 'bangalore', nearby: ['electronic-city', 'bommasandra', 'anekal', 'chandapura'] },
  { slug: 'bommasandra', name: 'Bommasandra', group: 'bangalore', nearby: ['hebbagodi', 'electronic-city', 'anekal', 'chandapura', 'hosur'] },
  { slug: 'chandapura', name: 'Chandapura', group: 'bangalore', nearby: ['anekal', 'electronic-city', 'bommasandra', 'hebbagodi'] },

  // Other cities in Karnataka
  { slug: 'mysuru', name: 'Mysuru', alt: 'Mysore', group: 'karnataka' },
  { slug: 'hubli-dharwad', name: 'Hubli-Dharwad', alt: 'Hubballi', group: 'karnataka' },
  { slug: 'mangaluru', name: 'Mangaluru', alt: 'Mangalore', group: 'karnataka' },
  { slug: 'belagavi', name: 'Belagavi', alt: 'Belgaum', group: 'karnataka' },
  { slug: 'kalaburagi', name: 'Kalaburagi', alt: 'Gulbarga', group: 'karnataka' },
  { slug: 'davanagere', name: 'Davanagere', alt: 'Davangere', group: 'karnataka' },
  { slug: 'ballari', name: 'Ballari', alt: 'Bellary', group: 'karnataka' },
  { slug: 'vijayapura', name: 'Vijayapura', alt: 'Bijapur', group: 'karnataka' },
  { slug: 'shivamogga', name: 'Shivamogga', alt: 'Shimoga', group: 'karnataka' },
  { slug: 'tumakuru', name: 'Tumakuru', alt: 'Tumkur', group: 'karnataka' },

  // Cities in Tamil Nadu
  // Only keep the cities you can really deliver to. Delete any line you cannot serve.
  // Add a real `note` to each one (delivery time, depot, local venues) so the page is not
  // the same as the others, for example:
  //   note: 'We deliver to Hosur from our Bangalore depot, usually the day before your event.'
  { slug: 'hosur', name: 'Hosur', group: 'tamilnadu', nearby: ['krishnagiri', 'bommasandra', 'electronic-city', 'anekal'] },
  { slug: 'krishnagiri', name: 'Krishnagiri', group: 'tamilnadu', nearby: ['hosur', 'salem', 'vellore'] },
  { slug: 'vellore', name: 'Vellore', group: 'tamilnadu', nearby: ['krishnagiri', 'chennai'] },
  { slug: 'salem', name: 'Salem', group: 'tamilnadu', nearby: ['krishnagiri', 'erode', 'coimbatore'] },
  { slug: 'erode', name: 'Erode', group: 'tamilnadu', nearby: ['salem', 'tiruppur', 'coimbatore'] },
  { slug: 'tiruppur', name: 'Tiruppur', alt: 'Tirupur', group: 'tamilnadu', nearby: ['coimbatore', 'erode'] },
  { slug: 'coimbatore', name: 'Coimbatore', group: 'tamilnadu', nearby: ['tiruppur', 'erode', 'salem'] },
  { slug: 'tiruchirappalli', name: 'Tiruchirappalli', alt: 'Trichy', group: 'tamilnadu', nearby: ['salem', 'madurai'] },
  { slug: 'madurai', name: 'Madurai', group: 'tamilnadu', nearby: ['tiruchirappalli'] },
  { slug: 'chennai', name: 'Chennai', group: 'tamilnadu', nearby: ['vellore'] },
];

export const cityPath = (slug) => `${CITY_BASE_PATH}/${slug}`;

export const getCity = (slug) => cities.find((c) => c.slug === slug);

// "Koramangala, Bangalore", "Mysuru (Mysore)" or "Hosur, Tamil Nadu"
export const cityFullName = (c) => {
  if (c.group === 'bangalore') return `${c.name}, Bangalore`;
  const base = c.alt ? `${c.name} (${c.alt})` : c.name;
  if (c.group === 'tamilnadu') return `${base}, Tamil Nadu`;
  return base;
};